// extracted by mini-css-extract-plugin
module.exports = {"loader":"spinner_loader__8R_VL","load6":"spinner_load6__ptbLF","round":"spinner_round__215M7"};